import { type FC } from 'react';

export const NewDesignToggleSkeleton: FC = () => {
  return (
    <div
      className={`
        grid items-center justify-between gap-md bg-background-surface-subdued
        px-2xl py-xl
        md:grid-cols-[1fr_auto]
        print:hidden
      `}
    >
      <span className="invisible" aria-hidden>
        New PRISMA Platform design - clearer workflow, better experience. Read
        the summary of all changes. Please leave feedback.
      </span>
    </div>
  );
};
